
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 133","d":"M51.47 44.16V28c0-10-5.32-18.29-14.59-20.5V5.25A4.89 4.89 0 0032 .38a4.83 4.83 0 00-4.83 4.83v2.24C17.84 9.66 12.55 18 12.55 28v16.16l-4.22 4.18a3.25 3.25 0 000 4.59 3.28 3.28 0 002.29 1h42.7a3.26 3.26 0 002.3-5.55zM32 63.62a6.51 6.51 0 006.49-6.49h-13A6.49 6.49 0 0032 63.62zm-16.93-56a3.18 3.18 0 00.22-4.51L15.15 3a3.25 3.25 0 00-4.51-.06A33.76 33.76 0 000 22.56a3.28 3.28 0 002.75 3.73 4 4 0 00.49 0 3.24 3.24 0 003.16-2.7 27.39 27.39 0 018.65-15.98zm38.37-4.7a3.28 3.28 0 00-4.56.08 3.18 3.18 0 000 4.5l.11.11a27.56 27.56 0 018.59 16 3.18 3.18 0 003.16 2.69A3.27 3.27 0 0064 22.51 34.05 34.05 0 0053.42 2.89z"}})])
          )
        }
      }
    